<template lang="html">

<svg width="21px" height="22px" viewBox="0 0 21 22" version="1.1">
    <g id="Symbols" stroke="none" stroke-width="1" :fill="this.colors.basic" fill-rule="evenodd" stroke-linejoin="round">
        <g id="INTRO" transform="translate(-806.000000, -24.000000)" :stroke="(!!this.colors.fontAlternative) ? this.colors.basic : this.colors.basic">
            <g id="notificaciones">
                <g transform="translate(798.000000, 16.000000)">
                    <g id="campana" transform="translate(9.000000, 9.000000)">
                        <path d="M12.993,16 C13,16.0609524 13,16.1295238 13,16.1904762 C13,18.2933333 11.432,20 9.5,20 C7.568,20 6,18.2933333 6,16.1904762 C6,16.1295238 6,16.0609524 6.007,16" id="Stroke-1"></path>
                        <path d="M3.39285714,5.76 C3.39285714,2.57856 6.12682143,0 9.5,0 C12.8731786,0 15.6071429,2.57856 15.6071429,5.76 L15.6071429,6.93376 C15.6071429,8.66752 16.1818929,10.3584 17.2506429,11.7696 L19,14.08 C19,14.08 16.7844643,16 9.5,16 C2.21553571,16 0,14.08 0,14.08 L1.74935714,11.7696 C2.81810714,10.3584 3.39285714,8.66752 3.39285714,6.93376 L3.39285714,5.76 Z" id="Stroke-5"></path>
                    </g>
                </g>
            </g>
        </g>
    </g>
</svg>

</template>

<script lang="js">
  
  import {mapGetters} from 'vuex';

  export default  {
    name: 'add',
    props: [],
    computed : {
      ...mapGetters({
        colors : 'basicColors'
      })
    }
}
</script>

<style scoped lang="scss">
  .add {

  }
</style>



// WEBPACK FOOTER //
// src/components/parts/icons/bell.vue